import { SvgIcon, type SvgIconProps } from "@mui/material";

export function DroneIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <g
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="m9 9-2-2m8 2 2-2m-8 8-2 2m8-2 2 2" />
        <circle cx="5" cy="5" r="3" />
        <circle cx="19" cy="5" r="3" />
        <circle cx="5" cy="19" r="3" />
        <circle cx="19" cy="19" r="3" />
        <path d="M3.5 5h3m11 0h3m-17 14h3m11 0h3" />
        <rect x="9" y="9" width="6" height="6" rx="1.5" />
        <path d="M12 10.75v2.5" />
      </g>
    </SvgIcon>
  );
}
